export const globalState = {
    translate: null,
};
